import React from 'react'
import Checkbox from '_/components/checkbox'

const getFieldValue = (formState, row, field, defaultValue) => {
  return formState?.find(item => item?.id === row?.id)?.[field] ?? defaultValue
}

export const profileColumns = (handleSetValue, formState) => [
  {
    field: 'permissionName',
    headerName: 'Permissão',
    minWidth: '100%',
    maxWidth: '100%',
    editable: false,
  },
  {
    field: 'read',
    headerName: 'Ver',
    editable: false,
    renderCell: ({ row, value }) => (
      <Checkbox
        checked={getFieldValue(formState, row, 'read', value)}
        name="read"
        onChange={event => handleSetValue(row, event.target?.name, event.target?.value)}
      />
    ),
  },
  {
    field: 'create',
    headerName: 'Gerenciar',
    editable: false,
    renderCell: ({ row, value }) => (
      <Checkbox
        checked={getFieldValue(formState, row, 'create', value)}
        name="create"
        onChange={event => handleSetValue(row, event.target?.name, event.target?.value)}
      />
    ),
  },
  {
    field: 'delete',
    headerName: 'Excluir',
    editable: false,
    renderCell: ({ row, value }) => (
      <Checkbox
        checked={getFieldValue(formState, row, 'delete', value)}
        name="delete"
        onChange={event => handleSetValue(row, event.target?.name, event.target?.value)}
      />
    ),
  },
]

export const TABLE_SX = {
  fontSize: '1.4rem',
  width: '100%',

  '& .MuiDataGrid-virtualScrollerRenderZone': {
    width: '100%',
  },

  '& .MuiDataGrid-columnHeadersInner': {
    width: '100%',

    '> div': {
      width: '100%',
    },
  },

  '& .MuiDataGrid-columnHeaders': {
    width: '100%',
  },

  '& .MuiDataGrid-columnHeader': {
    width: '100%',
  },

  '& .MuiDataGrid-row': {
    width: '100%',
  },

  '& .MuiDataGrid-cell': {
    width: '100%',
  },

  '& .MuiDataGrid-cell:hover': {
    cursor: 'pointer',
  },
}
